import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/fa-cached/css/all.min.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./comman.css";

ReactDOM.render(<App />, document.getElementById("root"));
